// extracted by mini-css-extract-plugin
module.exports = {"offerTag":"styles_offerTag__32gBm"};